/***********************************
  Menu Module
************************************/

var Cookies = require('js-cookie');
var prevScreenWidth = 0;

Quad.Hopscotch = ( function() {

//ACF vars Conversion, reference in FUNCTIONS.PHP 186-190.

var tooltip_onoff = acf_js_vars.tooltip_onoff,
    tooltip_expire_time  = acf_js_vars.tooltip_expire_time,
    tour;

  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    //Checking visitor status and date, to determinate if tooltip will be displayed.
    acfDate = new Date(tooltip_expire_time);
    today = new Date();
    UserCookie = Cookies.get(window.location.hostname + "-tooltip");

    if(tooltip_onoff && acf_js_vars.tooltip_steps.length > 0){
      tour = {
        id: 'quad-walkthrough',
        i18n: setStepButtonText(),
        steps: buildTooltipSteps()
      };
      setUpTooltipButton();

      if((today < acfDate || !acfDate.valueOf()) && !UserCookie && window.innerWidth > 767) {
        Cookies.set(window.location.hostname + "-tooltip", 'visited', { expires: acfDate });
        hopscotch.startTour( tour );
      }
    }
  }

  function setUpTooltipButton(){
    //Clickable icon tooltip
    var tooltip_icon =  document.getElementById( 'walkthrough' );
    if (tooltip_icon != null) {
      tooltip_icon.addEventListener( 'click', function() {
        hopscotch.endTour( true );
        if(window.innerWidth != prevScreenWidth) {
          tour.steps.map(function (x) {x.yOffset = getOffset()}); //In case the screen is resized, will change the offset.
        }
        hopscotch.startTour( tour );
      });
    }; 
  }

  function getMenuSelector(menuId){
    var returnItem;
    switch(menuId) {
      case "logins":
        returnItem = document.querySelector( '.main-nav-btn[data-menu="login"] > span.icon-user-login');
      break;
      case "search":
        returnItem = document.querySelector( '.main-nav-btn[data-menu="search"] > span.icon-search');
      break;
      //Main menu as default or if an invalid value is passed
      default: 
        returnItem = document.querySelector( '.main-nav-btn[data-menu="main"] > span.icon-menu' );
      break;
    }
    return returnItem;
  }
  
  //Helps keep the tooltip centered on the menu button depending on the screen size.
  function getOffset() {
    var screenWidth = window.innerWidth;
    prevScreenWidth = window.innerWidth;
    if(screenWidth > 2500) {
      return 0;
    }
    else if (screenWidth > 1300) {
      return -10;
    }
    else if (screenWidth > 1060) {
      return -15;
    }
    else if ( screenWidth > 768) {
      return -20
    }
    else {
      return 0;
    }
  }
  
  function buildTooltipSteps(){
    var built_steps = [];
    tooltip_steps = acf_js_vars.tooltip_steps;
    tooltip_steps.forEach(function(step, index){
      built_steps.push({
        content: step.step,
        target: getMenuSelector(step.menu_item_pointer),
        placement: 'right',
        showNextButton: true,
        fixedElement: true,
        title: step.title,
        showPrevButton: ( tooltip_steps.length > 1 && (index > 0) ) ? true : false,
        yOffset: getOffset(),
        onShow: function() {
          document.querySelector( '.hopscotch-bubble-close.hopscotch-close' ).addEventListener( 'click', function() {
            hopscotch.endTour( false );
          });
          //Add class for done icon
          if(index == tooltip_steps.length - 1) {
            document.querySelector('.hopscotch-next').classList.add('hopscotch-done-button');
          }
        }
      });
    });
  
    return built_steps;
  }

  function setStepButtonText() {
    var step_text;
    if(acf_js_vars.tooltip_transition_text_onoff){
      step_text = {
        nextBtn:  acf_js_vars.tooltip_step_transition_text.next,
        prevBtn:  acf_js_vars.tooltip_step_transition_text.previous,
        doneBtn:  acf_js_vars.tooltip_step_transition_text.done
      };
    }
    else {
      step_text = {
        nextBtn: " ",
        prevBtn: " ",
        doneBtn: " "
      };
    }

    return step_text;
  }

  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();


